/* unplugin-vue-components disabled */
import $global from 'stores/global'
import $prompts from 'stores/prompts'
import Rest from 'utils/rest'
import Duplicate  from './duplicate.vue'
import ShareError from './share-error.vue'
import ShareSkeleton from './share-skeleton.vue'
import {API_PROMPTS, API_SHARE_PROMPT} from 'consts/api'

export default {
  components: {
    Duplicate,
    ShareError,
    ShareSkeleton
  },
  data(){
    return {
      copying: false,
      owner: undefined,
      error: undefined
    }
  },
  computed:{
    prompt_id(){
      return this.$route.query.id
    },
    size(){
      if (this.$responsive.desktop) {
        return '54.4rem'
      }
      return '90%'
    }
  },
  async mounted(){
    this.$refs.modal.open()
    try {
      const $rest = new Rest()
      this.owner = await $rest.get(`${API_PROMPTS}/owner/${this.prompt_id}`)
    } catch (error) {
      if ([403, 404].includes(error.http_code)) {
        this.error = error
        return
      }
      throw error
    }
  },
  methods: {
    open(){
      this.$refs.modal.open()
    },

    async goToChats(){
      $global.goToChats()
    },

    async duplicate(){
      this.copying = true
      try {
        const $rest = new Rest()
        await $rest.post(`${API_SHARE_PROMPT}/${this.prompt_id}`)
        $utils.toasts.success('Prompt successfully copied. You can find it in your saved prompts.')
        await $prompts.load()
        this.goToChats()
      } 
      catch (error) {
        if ([403, 404].includes(error.http_code)) {
          this.error = error
          return
        }
        throw error
      }
      finally {
        this.copying = false
      }
    },
  },
}
